import { createApi } from "@reduxjs/toolkit/query/react";
import {
  ModelPortfolioSummary,
  OrderSimulationTemplateResponse,
} from "interfaces/EquityBasketInterface";
import { customBaseQuery } from "store/utils";

export const equityBasketApi = createApi({
  reducerPath: "equityBasketApi",
  baseQuery: customBaseQuery,
  tagTypes: ["Baskets", "OrderSimulationTemplates"],
  endpoints: (builder) => ({
    getBaskets: builder.query<ModelPortfolioSummary[], void>({
      query: () => "/model_portfolio/summary/",
      providesTags: ["Baskets"],
      keepUnusedDataFor: 10,
    }),
    getOrderSimulationTemplates: builder.query<
      OrderSimulationTemplateResponse,
      void
    >({
      query: () => "/order_manager_template/",
      providesTags: ["OrderSimulationTemplates"],
    }),
  }),
});

export const { useGetBasketsQuery, useGetOrderSimulationTemplatesQuery } =
  equityBasketApi;
